import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

interface iMyHeldBalanceState {
    items : []
}

export interface iUserMyHeldBalanceState {
    response : iMyHeldBalanceState | null;
    isLoading : boolean;
    message : string | null;
}

const initialState : iUserMyHeldBalanceState = {
    response : null,
    isLoading : false,
    message : null,
}

export const getUserMyHeldCreditBalanceAPI = createAsyncThunk(
    "GET_USER_MY_HELD_BALANCE",
    async (params: { runs: { group_name: string; library_name: string }[] }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/A7fQ9K2mXcP4R8sL/user/my-held-balance/';
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, params);
            return response.data;
        } catch (e) {
            console.error('User My Held Balance API 에러:', e);
            return rejectWithValue(e.response ? e.response.data : e.message);
        }
    }
)

export const userMyHeldCreditBalanceSlice = createSlice({
    name : "userMyHeldCreditBalance",
    initialState,
    reducers : {},
    extraReducers : (builder) => {
        builder
        .addCase(getUserMyHeldCreditBalanceAPI.pending, (state) => {
            state.isLoading = true;
            state.message = null;
        })
        .addCase(getUserMyHeldCreditBalanceAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(getUserMyHeldCreditBalanceAPI.rejected, (state, action) => {
            state.isLoading = false;
            state.message = action.payload as string;
        })
    }
})


export default userMyHeldCreditBalanceSlice.reducer;